import { createSelector } from '@ngrx/store';
import { getHistoryOrderByOrderId } from '../getHistoryOrderByOrderId';

export const getHistoryOrderVoucher = (orderId: number) =>
    createSelector(
        getHistoryOrderByOrderId(orderId),
        (order) =>
            (order?.data?.ActivatedVouchers?.length ? order.data?.ActivatedVouchers[0] : null)
    );
